export default __webpack_public_path__ + "aad474f29e693065c79b16fcaf0a5084.png";